const ItemButton = ({item, selected, changeItemSelection, search}) => {
    
    const getClasses = () => {
        let toReturn = "";

        if(!item.name.toLowerCase().includes(search.toLowerCase()))
            toReturn += " opacity-30";
    
        if(selected)
            toReturn += " itemButtonSelected";

        return toReturn;
    }
    return (   
        <p 
            title={item.name} 
            className={`itemButton ${getClasses()}`}
            onClick={() => changeItemSelection(item)}
        >
            <img className="w-10 h-10" src={item.url} />
        </p>
    )
}

export default ItemButton;